import React from 'react';
import { useContext } from 'react';
import SocialContext from '../../context/SocialContext';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Conform({deletePostId}) {
    const { open, setOpen ,deletePostID, logoutfun,deletePostfun ,conformMessage, setconformAction,conformAction} = useContext(SocialContext);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleCloseDisagree = () => {
        // setconformAction(false);
        setOpen(false);
    };

    const handleCloseAgree = () => {
        // setconformAction(true);
        setOpen(false);
        if(conformAction==="forlogout"){
            logoutfun();
        }
        if(conformAction=="fordeletepost"){
            console.log("Jai mahakal");
            deletePostfun(deletePostID);
        }
    };

    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
            <DialogTitle style={{'paddingBottom':'2px'}}>{conformMessage}</DialogTitle>
                <DialogActions style={{'paddingTop':'2px','paddingBottom':'2px'}}>
                    <Button onClick={handleCloseDisagree}>No</Button>
                    <Button onClick={handleCloseAgree}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
